var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('router-view',{ref:"router"}),_vm._v(" "),_c('context-menu',{staticClass:"right-menu",attrs:{"target":_vm.contextMenuTarget,"show":_vm.contextMenuVisible},on:{"update:show":function (show) { return _vm.contextMenuVisible = show; }}},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.refush}},[_vm._v("刷 新")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dc033d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 